import React, {Component} from "react";
import {route, routes} from "../../../vars/rd";

/**
 * 카테고리 버튼
 */
class CategoryGenre extends Component {
    /** @var {DaoCategory} */
    model;
    /** @var {function} */
    callback;

    constructor(props) {
        super(props);
        this.model = props.category;
        this.type = props.type;
        this.callback = props.onChange;
    }

    /**
     * 클릭
     */
    changeCategory() {
        if(!this.model.selected) {
            if(this.callback) this.callback(this.model);
            else route(routes.search_genre, this.model.proid);
        }
    }

    render() {
        switch (this.type) {
            case "menu":
                return (
                    <li className={`item ${this.model.selected ? 'on' : ''}`} onClick={() => this.changeCategory()}>
                        {this.model.proname}
                    </li>
                );
            default:
                return (
                    <div className={`item ${this.model.selected ? 'on' : ''}`} key={this.model.proid}>
                        <a onClick={() => this.changeCategory()}>{this.model.proname}</a>
                    </div>
                );
        }
    }
}

export default CategoryGenre;


// WEBPACK FOOTER //
// ./src/pages/components/buttons/category.genre.jsx